module.exports = __webpack_public_path__ + "static/media/geliya.3b53b440.jpg";